import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {OrderDataReviewed} from '../../order-request.models';

@Component({
    selector: 'order-box-history-reviewed',
    templateUrl: './order-box-history-reviewed.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrderBoxHistoryReviewedComponent {

  @Input() type: string;
  @Input() history: OrderDataReviewed;

  constructor() {
  }
}
